import React from 'react';
import classNames from 'classnames';
import Link from 'next/link';
import { Icon } from '../../subkit-ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var TWNavIconBlurb = function TWNavIconBlurb(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/_jsxs("div", {
    "data-cy": "nav-".concat(item.text),
    className: classNames('text-gray-900 cursor-pointer group flex items-center px-2 py-2 text-base font-sans font-medium rounded', {
      'bg-yellow-400': item.active,
      'text-gray-900 hover:bg-gray-100 hover:text-gray-900': !item.active
    }),
    children: [/*#__PURE__*/_jsxs("div", {
      className: "mr-4 h-8 w-8 flex justify-center items-center p-1",
      children: [item.iconUrl ? /*#__PURE__*/_jsx("img", {
        className: "w-full",
        src: item.iconUrl,
        alt: item.text
      }) : null, item.icon && /*#__PURE__*/_jsx(Icon, {
        type: "regular",
        name: item.icon,
        className: classNames('text-lg', item.iconClasses)
      })]
    }), item.text]
  });
};

export var TWNavIconBlurbList = function TWNavIconBlurbList(props) {
  var items = props.items,
      onListItemClick = props.onListItemClick;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("ul", {
      className: "space-y-4",
      children: items.map(function (item) {
        if ( /*#__PURE__*/React.isValidElement(item)) {
          return /*#__PURE__*/_jsx("li", {
            children: item
          }, item.key);
        }

        var iconBlurbItem = item;
        return !iconBlurbItem.hidden && /*#__PURE__*/_jsx("li", {
          onClick: onListItemClick,
          children: iconBlurbItem.href ? /*#__PURE__*/_jsx(Link, {
            href: iconBlurbItem.href,
            as: iconBlurbItem.href,
            children: /*#__PURE__*/_jsx("a", {
              target: iconBlurbItem.external ? '_blank' : '_self',
              rel: iconBlurbItem.external && 'noopener noreferrer',
              children: /*#__PURE__*/_jsx(TWNavIconBlurb, {
                item: iconBlurbItem
              })
            })
          }) : /*#__PURE__*/_jsx(TWNavIconBlurb, {
            item: iconBlurbItem
          })
        }, iconBlurbItem.text);
      })
    })
  });
};